import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Modal, Platform, ActivityIndicator } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { colores, fuentes } from '../../styles/variablesCss';
import { BACKEND_URL } from '../../Config/Const';
import { useUser } from '../../context/UserContext';
import { useCheckoutContext } from '../../context/CheckoutContext';

const UnificarEnvio = ({ visible, onClose, onConfirm, onReject }) => {
  const [loading, setLoading] = useState(false);
  // Usamos el contexto para los envíos pendientes
  const [envioSeleccionado, setEnvioSeleccionado] = useState(null);
  const [error, setError] = useState(null);
  const { mail, codUsu } = useUser();
  const { enviosPendientes, setEnviosPendientes } = useCheckoutContext();

  // Ya no cargamos envíos aquí, se cargan en ResumenPedido antes de mostrar el modal
  // useEffect(() => {
  //   if (visible) {
  //     cargarEnviosPendientes();
  //   }
  // }, [visible]);

  // Seleccionar el primer envío cuando se cargan los envíos pendientes
  useEffect(() => {
    if (enviosPendientes && enviosPendientes.length > 0) {
      setEnvioSeleccionado(enviosPendientes[0]);
    }
  }, [enviosPendientes]);

  const cargarEnviosPendientes = async () => {
    try {
      setLoading(true);
      setError(null);

      let userMail = mail;
      let userCodUsu = codUsu;

      // Obtener datos de autenticación
      if (Platform.OS === 'web') {
        userMail = localStorage.getItem('mail');
        userCodUsu = localStorage.getItem('codUsu');
      }

      const url = `${BACKEND_URL}/rest/fin/enviosPendientes?mail=${userMail}&codUsu=${userCodUsu}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();      
      // Extraer envíos pendientes del dsResultado
      // Probar diferentes estructuras posibles de la respuesta
      let envios = [];
      
      if (data?.dsResultado?.enviosPendientes) {
        envios = data.dsResultado.enviosPendientes;
      } else if (data?.response?.dsResultado?.dsResultado?.enviosPendientes) {
        envios = data.response.dsResultado.dsResultado.enviosPendientes;
      } else if (Array.isArray(data?.enviosPendientes)) {
        envios = data.enviosPendientes;
      }      
      // Guardar los envíos pendientes en contexto
      setEnviosPendientes(envios);
      
      // Si hay envíos, seleccionar el primero por defecto
      if (envios.length > 0) {
        setEnvioSeleccionado(envios[0]);
      } else {
        // Si no hay envíos pendientes, cerrar el modal automáticamente
        if (onReject) {
          onReject();
        }
      }
    } catch (err) {
      console.error('Error al cargar envíos pendientes:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      visible={visible}
      transparent={true}
      animationType="fade"
      onRequestClose={onClose}
    >
      <View style={styles.overlay}>
        <View style={styles.modalContainer}>
          {/* Icono de pregunta */}
          <View style={styles.iconContainer}>
            <MaterialCommunityIcons 
              name="package-variant" 
              size={60} 
              color={colores.rojo} 
            />
          </View>

          {/* Título */}
          <Text style={styles.titulo}>¿Quiere unificar pedido?</Text>

          {/* Mostrar loading o contenido */}
          {loading ? (
            <View style={styles.loadingContainer}>
              <ActivityIndicator size="large" color={colores.rojo} />
              <Text style={styles.loadingText}>Consultando envíos pendientes...</Text>
            </View>
          ) : error ? (
            <View style={styles.errorContainer}>
              <MaterialCommunityIcons name="alert-circle" size={40} color={colores.rojo} />
              <Text style={styles.errorText}>Error al cargar envíos pendientes</Text>
            </View>
          ) : (
            <>
              {/* Descripción */}
              <Text style={styles.descripcion}>
                {enviosPendientes.length > 0 
                  ? `Tiene ${enviosPendientes.length} envío(s) pendiente(s). Puede unificarlos en un solo envío para ahorrar en costos de flete.`
                  : 'Si tiene pedidos pendientes, puede unificarlos en un solo envío para ahorrar en costos de flete.'
                }
              </Text>

              {/* Select de envíos pendientes */}
              {enviosPendientes.length > 0 && (
                <View style={styles.selectContainer}>
                  <Text style={styles.selectLabel}>Seleccione el envío a unificar:</Text>
                  
                  {Platform.OS === 'web' ? (
                    <select
                      style={styles.selectWeb}
                      value={envioSeleccionado ? envioSeleccionado.codCompra : ''}
                      onChange={(e) => {
                        const selected = enviosPendientes.find(
                          envio => envio.codCompra === parseInt(e.target.value)
                        );
                        setEnvioSeleccionado(selected);
                      }}
                    >
                      {enviosPendientes.map((envio) => (
                        <option key={envio.codCompra} value={envio.codCompra}>
                          {`Pedido #${envio.codCompra} - ${envio.fechaEntrega} - ${envio.textoHora}`}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <View style={styles.pickerContainer}>
                      {enviosPendientes.map((envio) => (
                        <TouchableOpacity
                          key={envio.codCompra}
                          style={[
                            styles.pickerOption,
                            envioSeleccionado?.codCompra === envio.codCompra && styles.pickerOptionSelected
                          ]}
                          onPress={() => setEnvioSeleccionado(envio)}
                        >
                          <MaterialCommunityIcons 
                            name={envioSeleccionado?.codCompra === envio.codCompra ? "radiobox-marked" : "radiobox-blank"}
                            size={20}
                            color={envioSeleccionado?.codCompra === envio.codCompra ? colores.rojo : colores.gris}
                          />
                          <View style={styles.pickerOptionText}>
                            <Text style={styles.pickerOptionTitle}>Pedido #{envio.codCompra}</Text>
                            <Text style={styles.pickerOptionSubtitle}>
                              {envio.fechaEntrega} - {envio.textoHora}
                            </Text>
                          </View>
                        </TouchableOpacity>
                      ))}
                    </View>
                  )}
                  
                  {/* Info del envío seleccionado */}
                  {envioSeleccionado && (
                    <View style={styles.infoContainer}>
                      <MaterialCommunityIcons name="map-marker" size={16} color={colores.acento} />
                      <Text style={styles.infoText}>
                        {envioSeleccionado.calle} {envioSeleccionado.nro}
                      </Text>
                    </View>
                  )}
                </View>
              )}
            </>
          )}

          {/* Botones de acción */}
          {!loading && (
          <View style={styles.botonesContainer}>
            <TouchableOpacity
              style={[styles.boton, styles.botonRechazar]}
              onPress={onReject}
            >
              <Text style={styles.botonTextoRechazar}>No, continuar</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={[
                styles.boton, 
                styles.botonConfirmar,
                enviosPendientes.length > 0 && !envioSeleccionado && styles.botonDeshabilitado
              ]}
              onPress={() => {
                if (enviosPendientes.length > 0 && envioSeleccionado) {
                  onConfirm(envioSeleccionado);
                } else {
                  onConfirm(null);
                }
              }}
              disabled={enviosPendientes.length > 0 && !envioSeleccionado}
            >
              <Text style={styles.botonTextoConfirmar}>Sí, unificar</Text>
            </TouchableOpacity>
          </View>
          )}

          {/* Botón cerrar */}
          <TouchableOpacity style={styles.botonCerrar} onPress={onClose}>
            <MaterialCommunityIcons name="close" size={24} color={colores.textoSecundario} />
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  modalContainer: {
    backgroundColor: colores.blanco,
    borderRadius: 10,
    padding: 30,
    width: '100%',
    maxWidth: 500,
    alignItems: 'center',
    position: 'relative',
    ...(Platform.OS === 'web'
      ? { boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }
      : {
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 4 },
          shadowOpacity: 0.15,
          shadowRadius: 8,
          elevation: 8,
        }
    ),
  },
  iconContainer: {
    marginBottom: 20,
    padding: 15,
    backgroundColor: colores.fondoClaro || '#f5f5f5',
    borderRadius: 50,
  },
  titulo: {
    fontSize: 22,
    fontFamily: fuentes.bold || 'bold',
    color: colores.textoPrincipal || '#333',
    marginBottom: 15,
    textAlign: 'center',
  },
  descripcion: {
    fontSize: 15,
    fontFamily: fuentes.regular || 'normal',
    color: colores.textoSecundario || '#666',
    textAlign: 'center',
    marginBottom: 30,
    lineHeight: 22,
  },
  botonesContainer: {
    flexDirection: Platform.OS === 'web' ? 'row' : 'column',
    width: '100%',
    gap: 12,
  },
  boton: {
    flex: 1,
    paddingVertical: 14,
    paddingHorizontal: 20,
    borderRadius: 6,
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: Platform.OS === 'web' ? 150 : '100%',
  },
  botonConfirmar: {
    backgroundColor: colores.rojo,
    ...(Platform.OS === 'web'
      ? { boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }
      : {
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.1,
          shadowRadius: 4,
          elevation: 3,
        }
    ),
  },
  botonRechazar: {
    backgroundColor: colores.blanco,
    borderWidth: 2,
    borderColor: colores.grisClaro || '#ddd',
  },
  botonTextoConfirmar: {
    color: colores.blanco,
    fontSize: 16,
    fontFamily: fuentes.bold || 'bold',
    textTransform: 'uppercase',
  },
  botonTextoRechazar: {
    color: colores.textoPrincipal || '#333',
    fontSize: 16,
    fontFamily: fuentes.medium || 'normal',
  },
  botonCerrar: {
    position: 'absolute',
    top: 15,
    right: 15,
    padding: 5,
  },
  loadingContainer: {
    paddingVertical: 30,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 100,
  },
  loadingText: {
    marginTop: 15,
    fontSize: 14,
    color: colores.textoSecundario || '#666',
    fontFamily: fuentes.regular || 'normal',
  },
  errorContainer: {
    paddingVertical: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  errorText: {
    marginTop: 10,
    fontSize: 14,
    color: colores.rojo,
    fontFamily: fuentes.medium || 'normal',
    textAlign: 'center',
  },
  infoContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colores.fondoClaro || '#f5f5f5',
    padding: 12,
    borderRadius: 6,
    marginBottom: 15,
    gap: 8,
  },
  infoText: {
    fontSize: 13,
    color: colores.textoPrincipal || '#333',
    fontFamily: fuentes.medium || 'normal',
    fontWeight: '600',
  },
  selectContainer: {
    width: '100%',
    marginBottom: 20,
  },
  selectLabel: {
    fontSize: 14,
    fontFamily: fuentes.medium || 'normal',
    color: colores.textoPrincipal || '#333',
    marginBottom: 10,
    fontWeight: '600',
  },
  selectWeb: {
    width: '100%',
    padding: 12,
    fontSize: 14,
    borderWidth: 1,
    borderColor: colores.grisClaro || '#ddd',
    borderRadius: 6,
    backgroundColor: colores.blanco,
    fontFamily: fuentes.regular || 'normal',
    color: colores.textoPrincipal || '#333',
    cursor: 'pointer',
    marginBottom: 12,
  },
  pickerContainer: {
    width: '100%',
    marginBottom: 12,
  },
  pickerOption: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 12,
    borderWidth: 1,
    borderColor: colores.grisClaro || '#ddd',
    borderRadius: 6,
    marginBottom: 8,
    backgroundColor: colores.blanco,
  },
  pickerOptionSelected: {
    borderColor: colores.rojo,
    borderWidth: 2,
    backgroundColor: colores.fondoClaro || '#f5f5f5',
  },
  pickerOptionText: {
    flex: 1,
    marginLeft: 10,
  },
  pickerOptionTitle: {
    fontSize: 14,
    fontFamily: fuentes.medium || 'normal',
    color: colores.textoPrincipal || '#333',
    fontWeight: '600',
    marginBottom: 2,
  },
  pickerOptionSubtitle: {
    fontSize: 12,
    fontFamily: fuentes.regular || 'normal',
    color: colores.textoSecundario || '#666',
  },
  botonDeshabilitado: {
    backgroundColor: colores.grisClaro || '#ddd',
    opacity: 0.6,
  },
});

export default UnificarEnvio;
